import { Injectable } from '@angular/core';
import { SitedataService } from './sitedata.service';

@Injectable({
  providedIn: 'root'
})
export class LinksService {

  constructor(private siteData: SitedataService) { }

  getClearTextData(url) {
    return new Promise((resolve, reject) => {
      this.siteData.getClearText(url).subscribe(
        (ogsDataObject) => {
          resolve(ogsDataObject);
        },
        (error) => {
          
          reject(error);
        }
      );
    });
  }
}
